module.exports = __webpack_public_path__ + "static/preview-koen-95215fcda3aafecccdd335531ab86de5.wav";